import { get } from 'lodash'
import { ItemList } from '../../../../orm/index.js'
import { adminContactListVetting } from 'admin/components/contacts/actions/admin_contact'
import { adminAddressListVetting } from 'admin/components/addresses/actions/admin_address'
import { adminContactRoles } from 'admin/actions/admin_dropdown_options'

const PRIMARY_CONTACT_ROLE_LABEL = 'Primary contact'

export function hasPrimaryContactForVetting(beneficiary_id) {
  if (!beneficiary_id) return true
  const contactList = adminContactListVetting
  const contactRolesList = adminContactRoles
  const filter = contactList.getFilter()
  if (!filter || get(filter, 'beneficiary_vetting') !== beneficiary_id) return false
  const primaryRoleId = contactRolesList.getOptionValueForLabel(PRIMARY_CONTACT_ROLE_LABEL)
  if (primaryRoleId == null) return false
  const contacts = contactList.getVisibleObjects() || []
  const roleIds = (c) => {
    const r = get(c, 'roles', [])
    return Array.isArray(r) ? r.map((x) => (x && typeof x === 'object' ? get(x, 'id') || get(x, 'ref') : x)) : []
  }
  return contacts.some((c) => roleIds(c).includes(primaryRoleId))
}

export function hasAtLeastOneAddressForVetting(beneficiary_id) {
  if (!beneficiary_id) return true
  const addressList = adminAddressListVetting
  const filter = addressList.getFilter()
  if (!filter || get(filter, 'beneficiary_vetting') !== beneficiary_id) return false
  const addresses = addressList.getVisibleObjects() || []
  return addresses.length >= 1
}

class AdminBeneficiaryVettingList extends ItemList {
    getEntityKey() {
        return 'admin/beneficiary_vetting'
    }

    approveVetting({ beneficiary_vetting_id }) {
        if (!beneficiary_vetting_id) {
            return (dispatch) => Promise.reject(new Error('Beneficiary vetting id is required to approve.'))
        }
        return this.postAction(`${beneficiary_vetting_id}/approve`, {})
    }
}

export const adminBeneficiaryVettingList = new AdminBeneficiaryVettingList(
    'admin_beneficiary_vetting__default'
)